<template>
    <b-card :title="$translate('filters')" body-class="p-0" class="query-filter filter-form mt-3">
        <div>
            <b-row>
                <b-col cols="12" md="3" class="mt-3">
                    <label for="fieldset-customer" class="mb-3"><strong>{{ $translate('customer') }}</strong></label>
                    <customer-type-ahead v-model="filtersModel.customer_id" />
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="input-default-engineer-id" class="mb-3"><strong>{{ $translate('agent') }}</strong></label>
                    <b-form-select class="form-control" id="input-default-engineer-id"
                        v-model="filtersModel.default_engineer_id" value-field="id" text-field="name" :options="officers">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('any_officer') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="fieldset-role-id" class="mb-3"><strong>{{ $translate('roles') }}</strong></label>
                    <b-form-select class="form-control" id="input-role-id" v-model="filtersModel.role_id" value-field="id"
                        text-field="name" :options="roles">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_role') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="input-assetType" class="mb-3"><strong>{{ $translate('type') }}</strong></label>
                    <b-form-select class="form-control" id="input-assetType" v-model="filtersModel.type_id" value-field="id"
                        text-field="name" :options="types" :disabled="crm">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('any_role') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <!-- <b-col cols="12" md="6" class="mt-3 dd">
                    <label for="fieldset-role-id" class="mb-3"><strong>{{ $translate('frequency') }}</strong></label>
                    <b-form-select class="form-control" id="input-frequency-id" v-model="filtersModel.frequency" value-field="id" text-field="name" :options="assetFrequencies">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_frequency') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col> -->
            </b-row>
            <b-row v-if="!crm">
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-warranty_from" class="mb-3"><strong>{{$translate('warranty_from')}}</strong></label>
                    <b-form-input type="date" id="input-warranty_from" v-model="filtersModel.warranty_from"></b-form-input>
                </b-col>

                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-warranty_to" class="mb-3"><strong>{{$translate('warranty_to')}}</strong></label>
                    <b-form-input type="date" id="input-warranty_to" v-model="filtersModel.warranty_to"></b-form-input>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-last_service_from" class="mb-3"><strong>{{$translate('last_service_from')}}</strong></label>
                    <b-form-input type="date" id="input-last_service_from"
                        v-model="filtersModel.last_service_from"></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-last_service_to" class="mb-3"><strong>{{$translate('last_service_to')}}</strong></label>
                    <b-form-input type="date" id="input-last_service_to"
                        v-model="filtersModel.last_service_to"></b-form-input>
                </b-col>
            </b-row> -->
            <!-- <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-next_service_from" class="mb-3"><strong>{{$translate('next_service_from')}}</strong></label>
                    <b-form-input type="date" id="input-next_service_from"
                        v-model="filtersModel.next_service_from"></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-next_service_to" class="mb-3"><strong>{{$translate('next_service_to')}}</strong></label>
                    <b-form-input type="date" id="input-next_service_to"
                        v-model="filtersModel.next_service_to"></b-form-input>
                </b-col>
            </b-row> -->
             <b-row class="mt-3">
                    <b-col cols="12" class="mb-3">
                        <label><strong>{{ $translate('available_for_rental') }}</strong></label>
                    </b-col>
                    <b-col cols="auto" class="mb-3">
                        <b-form-radio
                            id="available_for_rental-yes"
                            v-model="filtersModel.available_for_rental"
                            name="available_for_rental"
                            value="yes"
                            class="mx-1"
                            
                        >&nbsp;{{$translate('yes')}}</b-form-radio>
                    </b-col>
                    <b-col cols="auto" class="mb-3">
                        <b-form-radio
                         id="available_for_rental-no"
                            v-model="filtersModel.available_for_rental"
                            name="available_for_rental"
                            value="no"
                            class="mr-2"
                            
                        >&nbsp;{{$translate('no')}}</b-form-radio>
                    </b-col>
                </b-row>
        </div>
    </b-card>
</template>

<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead'

export default {
    name: 'assets-reportQueryBuilder',
    components: { CustomerTypeAhead },
    data: () => ({}),
    props: ['value', 'types', 'crm', 'officers', 'roles', 'asset-frequencies'],

    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    watch: {},
}
</script>
